import ProjectCardBadges from './ProjectCardBadges/ProjectCardBadges'
import ProjectDetailMainCard from './ProjectDetailMainCard/ProjectDetailMainCard'
import ProjectDetailsCertification from './ProjectDetailsCertification/ProjectDetailsCertification'
import ProjectDetailsCollapse from './ProjectDetailsCollapse/ProjectDetailsCollapse'
import ProjectDetailsDescription from './ProjectDetailsDescription/ProjectDetailsDescription'
import ProjectDetailsGallery from './ProjectDetailsGallery/ProjectDetailsGallery'
import ProjectDetailsImpacts from './ProjectDetailsImpacts/ProjectDetailsImpacts'
import ProjectDetailsInfoContent from './ProjectDetailsInfoContent/ProjectDetailsInfoContent'
import ProjectDetailsRecentPurchases from './ProjectDetailsRecentPurchases/ProjectDetailsRecentPurchases'
import ProjectDetailsVideo from './ProjectDetailsVideo/ProjectDetailsVideo'
import ProjectDetailsVintageItems from './ProjectDetailsVintageItems/ProjectDetailsVintageItems'
import ProjectKindContent from './ProjectKindContent/ProjectKindContent'
import ProjectPriceDetailCard from './ProjectPriceDetailCard/ProjectPriceDetailCard'
import ProjectSdgDetailsList from './ProjectSdgDetailsList/ProjectSdgDetailsList'
import ProjectTaxReliefDetails from './ProjectTaxReliefDetails/ProjectTaxReliefDetails'

export const content = {
  ProjectCardBadges,
  ProjectDetailsCertification,
  ProjectDetailsDescription,
  ProjectDetailsGallery,
  ProjectDetailsImpacts,
  ProjectDetailsInfoContent,
  ProjectDetailsRecentPurchases,
  ProjectDetailsVideo,
  ProjectDetailsVintageItems,
  ProjectKindContent,
  ProjectPriceDetailCard,
  ProjectSdgDetailsList,
  ProjectTaxReliefDetails,
  ProjectDetailMainCard,
}

export {
  ProjectDetailsCollapse
}
